module.exports = __webpack_public_path__ + "assets/media/dot.65c6606e.svg";